import Vue from 'vue'
import App from './App.vue'

import 'bootstrap/dist/css/bootstrap.min.css'

// Only the specific icons this hotsite actually uses are imported as SVG
// components, instead of loading FontAwesome's full icon-font (which pulled
// in ~1.6MB of glyphs for every icon in the free set, used or not).
// If a future data.json swaps in a brand/icon not listed here, add its
// import + library.add() entry below — see parseIcon() in Home.vue.
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faTwitter,
  faInstagram,
  faTiktok,
  faYoutube,
  faTwitch,
  faMicrosoft,
  faSteam,
  faAmazon
} from '@fortawesome/free-brands-svg-icons'
import {
  faGamepad,
  faShoppingBag,
  faEnvelope,
  faCircle
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faTwitter, faInstagram, faTiktok, faYoutube, faTwitch, faMicrosoft, faSteam, faAmazon,
  faGamepad, faShoppingBag, faEnvelope, faCircle
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
